import axios from 'axios';
import React, { useEffect, useState } from 'react'

import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import EditNoteIcon from '@mui/icons-material/EditNote';
import MenuIcon from '@mui/icons-material/Menu';
import { v4 as UUIDV4 } from 'uuid';
import Form from 'react-bootstrap/Form';
function Users({ serverURL, user, setUser, setShowSideOverlay }) {
    const [allRows, setAllRows] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [allForms, setAllForms] = useState([])

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [password, setPassword] = useState("");
    const [doj, setDOJ] = useState("");
    const [location, setLocation] = useState("");
    const [designation, setDesignation] = useState("User");
    const [manager, setManager] = useState("NA");
    const [department, setDepartment] = useState("");
    const [status, setStatus] = useState("Active");
    const [doe, setDOE] = useState("");

    const [chosenForms, setChosenForms] = useState(null)
    const [chosenPermissions, setChosenPermissions] = useState(null)

    const [assignedForms, setAssignedForms] = useState([])
    const [formOptions, setFormOptions] = useState([])
    const [permissionOptions, setPermissionOptions] = useState([
        { "label": "Home", "value": "Home" },
        { "label": "Yes-Family", "value": "Yes-Family" },
        { "label": "Edit-Employee-Details", "value": "Edit-Employee-Details" },
        { "label": "Hierarchy-Tree", "value": "Hierarchy-Tree" },
        { "label": "Policies", "value": "Policies" },
        { "label": "Policy-Logs", "value": "Policy-Logs" },
        { "label": "Policy-Create", "value": "Policy-Create" },
        { "label": "Forms", "value": "Forms" },
        { "label": "Form-Data", "value": "Form-Data" },
        { "label": "Tickets", "value": "Tickets" },
        { "label": "Tickets-Dashboard", "value": "Tickets-Dashboard" },
        { "label": "Ticket-Assignment-Rule", "value": "Ticket-Assignment-Rule" },
        { "label": "Department-KPI", "value": "Department-KPI" },
        { "label": "Student-Consent", "value": "Student-Consent" },
        { "label": "CV-Dashboard", "value": "CV-Dashboard" },
        { "label": "university-dashboard", "value": "university-dashboard" },
        { "label": "Document-Dashboard", "value": "Document-Dashboard" },
        { "label": "Student-Funnel", "value": "Student-Funnel" },
        { "label": "Student-Mail", "value": "Student-Mail" },
        { "label": "Mail-Connection-Status", "value": "Mail-Connection-Status" },
        { "label": "YG-Mail-Dashboard", "value": "YG-Mail-Dashboard" },
        { "label": "Student-Master", "value": "Student-Master" },
        { "label": "Automation-Monitor", "value": "Automation-Monitor" },
        { "label": "Download-History", "value": "Download-History" },
        { "label": "View-Unassigned-Tickets", "value": "View-Unassigned-Tickets" },
        { "label": "Unassigned-Ticket-Assignment", "value": "Unassigned-Ticket-Assignment" },
        { "label": "CL-Dashboard", "value": "CL-Dashboard" },
        { "label": "CL-Dashboard", "value": "CL-Dashboard" },
        { "label": "Student-Reference-View", "value": "Student-Reference-View" },
        { "label": "Student-Reference-Update", "value": "Student-Reference-Update" },
        { "label": "aps-Dashboard", "value": "aps-Dashboard" },
        { "label": "Settings", "value": "Settings" },
    ])

    const [showToast, setShowToast] = useState(false)
    const [toastTitle, setToastTitle] = useState("")
    const [toastType, setToastType] = useState("")
    const [toastMessage, setToastMessage] = useState("")

    const [showEditUserModal, setShowEditUserModal] = useState(false);
    const [editUserData, setEditUserData] = useState({});


    const getAllForms = async () => {
        const getAllForms = await axios.post(serverURL + "/forms/getAll")
        if (getAllForms.status === 200) {
            // console.log(getAllForms.data)
            if (user.userType !== "admin") {
                let filteredId = []
                user.assignedForms.map((ids, key) => {
                    return filteredId.push(ids.value)
                })
                const fiteredFormData = getAllForms.data.filter((form) => {
                    return filteredId.includes(form._id)
                })
                console.log(fiteredFormData)
                setAllForms(fiteredFormData)
            } else {
                setAllForms(getAllForms.data)
                setFormOptions(getAllForms.data)
            }
        }
        else {
            console.log(getAllForms.data)
        }
    }

    const getAllRows = async () => {
        const getNow = await axios.post(serverURL + "/users/getAllData");
        if (getNow.status === 200) {
            setAllRows(getNow.data)
        } else {
            console.log(getNow.data)
        }
    }

    const addNewData = async (e) => {
        e.preventDefault();

        let lastNumber = "0";

        if (allRows.length > 0) {
            lastNumber = allRows[allRows.length - 1].employeeCode;
        }

        const query = {
            "name": name,
            "employeeCode": "YES" + (parseInt(lastNumber.replaceAll("YES", "")) + 1).toString().padStart(5, "0"),
            "email": email,
            "mobile": mobile,
            "password": UUIDV4().split("-")[0],
            "assignedForms": chosenForms,
            "permissions": chosenPermissions,
            "doj": doj,
            "userType": "user",
            "location": location,
            "designation": designation,
            "manager": manager,
            "department": department,
            "status": status,
            "doe": doe,
        }

        const addNewData = await axios.post(serverURL + "/users/register", query);

        if (addNewData.status === 200) {
            e.target.reset();
            console.log(addNewData.data)

            setName("")
            setEmail("")
            setMobile("")
            setPassword("")
            setChosenForms(null)
            setStatus("Active")


            getAllRows();

            setShowToast(true)
            setToastTitle("Saved")
            setToastType("success")
            setToastMessage("User Saved")

            setTimeout(() => {
                setShowModal(false)
            }, 3000)
        } else {

            setShowToast(true)
            setToastTitle("Error")
            setToastType("error")
            setToastMessage(addNewData.data)

            console.log(addNewData.data)
        }
    }

    const updateFormData = async (e) => {
        e.preventDefault();

        const query = {
            "sourceUserId": editUserData._id,
            "origionalUserId": user._id,
            "data": {
                // "name": name,
                // "employeeCode": editUserData.employeeCode,
                // "email": email,
                // "mobile": mobile,
                // "password": editUserData.password,
                "assignedForms": chosenForms,
                "permissions": chosenPermissions,
                // "doj": editUserData.doj,
                // "userType": editUserData.userType,
                // "location": editUserData.location,
                // "designation": designation,
                // "manager": manager,
                // "department": editUserData.department,
                // "status": status,
                // "doe": editUserData.doe,
            }
        }

        const addNewData = await axios.post(serverURL + "/users/updateUser", query);

        if (addNewData.status === 200) {
            e.target.reset();
            // console.log(addNewData.data)

            setUser(addNewData.data)

            getAllRows();

            setShowToast(true)
            setToastTitle("Saved")
            setToastType("success")
            setToastMessage("User Updated")

            setTimeout(() => {
                setShowToast(false)
                setShowEditUserModal(false)
            }, 2000)
        } else {

            setShowToast(true)
            setToastTitle("Error")
            setToastType("error")
            setToastMessage(addNewData.data)

            // console.log(addNewData.data)
        }
    }

    const editUser = async (userData) => {
        // console.log(userData)
        setName(userData.name)
        setEmail(userData.email)
        setMobile(userData.mobile)
        setPassword(userData.password)
        setStatus(userData.status)
        setChosenForms(userData.assignedForms ? userData.assignedForms : null)
        setChosenPermissions(userData.permissions ? userData.permissions : null)

        setShowEditUserModal(true)
        setEditUserData(userData)
    }

    const resetFields = () => {
        setName("")
        setEmail("")
        setMobile("")
        setPassword("")
        setStatus("Active")
        setChosenForms(null)
        setEditUserData({})
    }

    const changeUserState = async (id, state) => {
        const query = { "id": id, "state": state }
        const changeStateNow = await axios.post(serverURL + "/users/changeState", query)
        if (changeStateNow.status === 200) {
            console.log(changeStateNow.data)
        } else {
            console.log(changeStateNow.data)
        }
    }
    useEffect(() => {
        getAllForms()
        getAllRows()
    }, [])

    return (
        <>
            <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Users Section</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='my-3'>
                    <button className='btn btn-sm btn-dark rounded-pill px-5' onClick={() => { setShowModal(true) }}>Add New</button>
                </div>
                <div className='w-100 h-100 overflow-auto'>
                    {
                        allRows.length > 0 ?
                            <table className='table table-yesgermany table-bordered table-light mb-0'>
                                <thead className='table-dark sticky-top'>
                                    <tr align="center">
                                        <th className='text-nowrap'>#{allRows.length}</th>
                                        {/* <th >Employee Id</th> */}
                                        <th>Name</th>
                                        <th>Official Email</th>
                                        <th>Mobile</th>
                                        <th>Designation</th>
                                        <th>Manager</th>
                                        <th>Options</th>

                                        {/* <th>Date of Exit</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        allRows.map((data, key) => {
                                            return (
                                                <tr key={key} align="center">
                                                    <td valign='middle'>{key + 1}</td>
                                                    {/* <td valign='middle'>{data.employeeCode}</td> */}
                                                    <td valign='middle'>{data.name}</td>
                                                    <td valign='middle'>{data.email}</td>
                                                    <td valign='middle'>{data.mobile}</td>
                                                    <td>{data.designation ? data.designation : "NA"}</td>
                                                    <td>{data.manager ? data.manager : "NA"}</td>
                                                    <td valign='middle'><button id={data._id} className='btn btn-sm btn-warning fw-bold px-3 rounded-pill' onClick={(e) => { editUser(data) }}><EditNoteIcon /></button></td>
                                                </tr>
                                            )
                                        })

                                    }
                                </tbody>
                            </table>
                            :
                            <div className="glassInfo text-center rounded-0">
                                No Users Available
                            </div>
                    }
                </div>
            </div>

            {/*############################## New User Start ###############################*/}
            <Modal
                show={showModal}
                size='md'
                backdrop="static"
                onHide={() => { setShowModal(false) }}
                centered
            >
                <form action="" onSubmit={(e) => { addNewData(e); }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span className='themeTextColor'>
                                Create User
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label>Name</label>
                        <input className='form-control shadow-sm mb-2' type="text" placeholder='' value={name} onInput={(e) => { setName(e.target.value) }} />
                        <label>Official Email</label>
                        <input className='form-control shadow-sm mb-2' type="email" placeholder='' value={email} onInput={(e) => { setEmail(e.target.value) }} />
                        <label>Mobile</label>
                        <input className='form-control shadow-sm mb-2' type="tel" placeholder='' maxLength={10} minLength={10} value={mobile} onInput={(e) => { setMobile(e.target.value) }} />
                        {/* <label>Password</label>
                        <input className='form-control shadow-sm mb-2' type="password" placeholder='' value={password} onInput={(e) => { setPassword(e.target.value) }} /> */}
                        <label htmlFor="">Assign Form</label>
                        <Select
                            className='w-100'
                            placeholder="Select Forms"
                            value={chosenForms}
                            onChange={setChosenForms}
                            autoFocus={false}
                            isMulti={true}
                            isSearchable={true}
                            required={false}
                            options={formOptions.map((data, key) => {
                                return { "value": data._id, "label": data.name }
                            })}
                        />
                        <label htmlFor="">Assign Permissions</label>
                        <Select
                            className='w-100'
                            placeholder="Select Forms"
                            value={chosenPermissions}
                            onChange={setChosenPermissions}
                            autoFocus={false}
                            isMulti={true}
                            isSearchable={true}
                            required={false}
                            options={permissionOptions.map((data, key) => {
                                return { "value": data, "label": data }
                            })}
                        />

                        {/* <label>DOJ</label>
                        <input className='form-control shadow-sm mb-2' type="date" placeholder='' value={doj} onInput={(e) => { setDOJ(e.target.value) }} />
                        <label>Location</label>
                        <input className='form-control shadow-sm mb-2' type="text" placeholder='' value={location} onInput={(e) => { setLocation(e.target.value) }} /> */}


                        <label>Role</label>
                        <select name="" className='form-control shadow-sm mb-2' type="text" placeholder='' value={designation} onInput={(e) => { setDesignation(e.target.value) }} >
                            <option value="Admin">Admin</option>
                            <option value="Manager">Manager</option>
                            <option value="User">User</option>
                        </select>

                        {
                            designation !== "Admin" ?
                                <>
                                    <label>Reporting To</label>
                                    <select name="" className='form-control shadow-sm mb-2' type="text" placeholder='' value={manager} onInput={(e) => { setManager(e.target.value) }} >
                                        {
                                            allRows.filter((user) => {
                                                return user.designation === "Manager"
                                            }).length > 0 ?
                                                allRows.filter((user) => {
                                                    return user.designation === "Manager"
                                                }).map((opt, key) => {
                                                    return (
                                                        <option key={key} value={opt.email}>
                                                            {opt.name}
                                                        </option>
                                                    )
                                                })
                                                :
                                                <option value="NA">
                                                    NA
                                                </option>
                                        }
                                    </select>
                                </>
                                :
                                ""
                        }


                        {/* <label>Manager</label>
                        <input className='form-control shadow-sm mb-2' type="text" placeholder='' value={manager} onInput={(e) => { setManager(e.target.value) }} />
                        <label>Department</label>
                        <input className='form-control shadow-sm mb-2' type="text" placeholder='' value={department} onInput={(e) => { setDepartment(e.target.value) }} /> */}



                        {/* <label>Status</label>
                        <select className='form-control shadow-sm mb-4' value={status} onInput={(e) => { setStatus(e.target.value) }}>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </select> */}
                        {/* <label>DOE</label>
                        <input className='form-control shadow-sm mb-2' type="date" placeholder='' value={doe} onInput={(e) => { setDOE(e.target.value) }} /> */}

                        {
                            showToast ?
                                <div className={`alert alert-${toastType === "error" ? "danger" : "success"} p-0 w-100 text-center`}>
                                    {toastMessage}
                                </div>
                                :
                                ""
                        }


                    </Modal.Body>
                    <Modal.Footer>
                        <input type="reset" className="btn btn-sm rouded-pill px-3 btn-secondary" value={"Reset"} />
                        <input type="submit" className="btn btn-sm rouded-pill px-3 btn-success" value={"Save Now"} />
                    </Modal.Footer>
                </form>
            </Modal>


            {/*############################## Edit User Start ###############################*/}
            <Modal
                show={showEditUserModal}
                size='md'
                backdrop="static"
                onHide={() => { setShowEditUserModal(false); resetFields(); }}
                centered
            >
                <form action="" onSubmit={(e) => { updateFormData(e); }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span className='themeTextColor'>
                                Edit {editUserData.email}
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label htmlFor="">Assign Form</label>
                        <Select
                            className='w-100'
                            placeholder="Select Forms"
                            value={chosenForms}
                            onChange={setChosenForms}
                            autoFocus={false}
                            isMulti={true}
                            isSearchable={true}
                            required={false}
                            options={formOptions.map((data, key) => {
                                return { "value": data._id, "label": data.name }
                            })}
                        />
                        <label htmlFor="">Assign Permissions</label>
                        <Select
                            className='w-100'
                            placeholder="Select Forms"
                            value={chosenPermissions}
                            onChange={setChosenPermissions}
                            autoFocus={false}
                            isMulti={true}
                            isSearchable={true}
                            required={false}
                            options={permissionOptions}
                        />

                        {
                            showToast ?
                                <div className={`alert alert-${toastType === "error" ? "danger" : "success"} p-0 w-100 text-center`}>
                                    {toastMessage}
                                </div>
                                :
                                ""
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {/* <input type="reset" className="btn btn-sm rouded-pill px-3 btn-secondary" value={"Reset"} /> */}
                        <input type="submit" className="btn btn-sm rouded-pill px-3 btn-success" value={"Update"} />
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default Users